import React from "react";
import { useTranslation } from "react-i18next";
import PageHeaderSolutions from "../components/PageHeaderSolutions";
import { CaretRightFilled } from "@ant-design/icons";
// import public_health from "../assets/images/applications/market_basket_analysis.jpg";
import HealthcareBanner from "../appareas/HealthcareBanner";

const PublicHealth = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeaderSolutions></PageHeaderSolutions>
      <section className="mt-24 w-full h-full relative bg-center bg-cover p-5 border-2 border-blue-900 rounded-lg bg-white">
        <div> <HealthcareBanner></HealthcareBanner> </div>
        <div className="items-center text-center">
          <h3 className="mt-2 text-blue-900 text-4xl font-semibold mb-2">
            {t("public_health")}
          </h3>
        </div>

        <p className="text-2xl">
          <CaretRightFilled />
          {t("public_health_description1")}
        </p>


        {/* <img src={public_health} width={1200} height={1200} alt="public_health" /> */}
      </section>
    </>
  );
};

export default PublicHealth;
